import { ActionTree, GetterTree, MutationTree, Module } from 'vuex';
import i18n from '@/i18n';
import { RootState } from '../interfaces/rootState';
import { postWithAuthPayload } from '@/util/HTTPCommpix';
import { WithdrawalsBalance, WithdrawalsQuotation, WithdrawalsState } from '@/store/interfaces/commpix-api/withdrawals';

const state: WithdrawalsState = {
  balance: null,
  balanceError: null,
  quotation: null,
  quotationError: null,
};

const mutations: MutationTree<WithdrawalsState> = {
  setBalance(state, balance: WithdrawalsBalance) {
    state.balance = balance;
  },
  setBalanceError(state, error: string | null) {
    state.balanceError = error;
  },
  setQuotation(state, quotation: WithdrawalsQuotation) {
    state.quotation = quotation;
  },
  setQuotationError(state, error: string | null) {
    state.quotationError = error;
  },
  clearQuotation(state) {
    state.quotation = null;
    state.quotationError = null;
  },
};

const actions: ActionTree<WithdrawalsState, RootState> = {
  async fetchWithdrawalsBalance({ commit, }) {
    commit('setBalanceError', null);
    try {
      const response = await postWithAuthPayload('/commpix/withdrawals/balance');
      commit('setBalance', response.data);
    } catch (error) {
      const errorMsg = (error instanceof Error ? error.message : 'Error al cargar el balance');
      commit('setBalanceError', errorMsg);
    }
  },
  async fetchWithdrawalsQuotation({ commit, }) {
    commit('setQuotationError', null);
    try {
      const response = await postWithAuthPayload('/commpix/withdrawals/quotation');
      commit('setQuotation', response.data);
    } catch (error) {
      const errorMsg = (error instanceof Error ? error.message : 'Error al solicitar cotización');
      commit('setQuotationError', errorMsg);
    }
  },
  async createWithdrawal(_vuex, { quotationId, }) {
    return postWithAuthPayload('/commpix/withdrawals', { quotationId, })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        let message = i18n.t('error.withdrawals.default');
        if (error && error.response && error.response.data && error.response.data.status === 409) {
          message = i18n.t('error.withdrawals.409');
        } else if (error && error.message) {
          message = error.message;
        }
        return Promise.reject(message);
      });
  },
  async clearWithdrawalsQuotation({ commit, }) {
    commit('clearQuotation');
  },
};

const getters: GetterTree<WithdrawalsState, RootState> = {
  withdrawalsBalance: state => state.balance,
  withdrawalsBalanceError: state => state.balanceError,
  withdrawalsQuotation: state => state.quotation,
  withdrawalsQuotationError: state => state.quotationError,
};

export const withdrawals: Module<WithdrawalsState, RootState> = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default withdrawals;
